import Konva from "konva";
import { KonvaEventObject } from "konva/lib/Node";
import React, { useRef } from "react";
import { Text } from "react-konva";

import { TextEditor } from "./TextEditor";

type EditableTextProps = {
  fill?: string;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  text?: string;
  onTextChange?: (newText: string) => void;
  isEditing?: boolean;
  onMouseDown?: (event: KonvaEventObject<MouseEvent>) => void;
  fontSize?: number;
  zoom?: number;
  onDblClick?: (event: KonvaEventObject<MouseEvent>) => void;
};

const TEXT_PADDING = 10;

export function EditableText({
  fill,
  x = 0,
  y = 0,
  width = 0,
  height = 0,
  text = "",
  onTextChange,
  isEditing,
  onMouseDown,
  fontSize = 24,
  zoom = 1,
  onDblClick,
}: EditableTextProps) {
  const textRef = useRef<Konva.Text>(null);

  const handleTextChange = (newText: string) => {
    onTextChange?.(newText);
  };

  const padding = TEXT_PADDING / zoom;

  return (
    <>
      <Text
        ref={textRef}
        text={text}
        x={x + padding}
        y={y + padding}
        fontSize={fontSize / zoom}
        fontFamily="Barlow"
        width={width - padding}
        height={height - padding}
        onMouseDown={onMouseDown}
        visible={!isEditing}
        fill={fill}
        onDblClick={onDblClick}
      />
      {isEditing && textRef.current && (
        <TextEditor textNode={textRef.current} onChange={handleTextChange} height={height - padding} />
      )}
    </>
  );
}
